import React from 'react';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Grid } from '@material-ui/core';
import Content from 'components/basics/Content';
import { colors } from 'styles';
import { FormattedMessage } from 'react-intl';
import { breakpoint } from 'utils/mediaQueries';

const StyledGrid = styled(Grid)`
  ${Content};
  padding-top: 4rem;
  ${breakpoint.down('lg')`
  padding-top: 0;margin-top:-6rem`};
  ${breakpoint.down('md')`margin-top:-2rem`};
  ${breakpoint.down('sm')`margin-top:0`};
  ${breakpoint.down('xs')`
  margin-top: -4rem;`};
`;
const StyledFormControl = styled(FormControl)`
  width: 100%;
  display: flex;
  align-items: center;
`;
const StyledSelect = styled(Select)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  outline: none;
  background-color: rgba(173, 147, 160, 0.1);
  border-radius: 1rem;
  > div {
    display: flex;
    flex-direction: row;
  }
  > div > div {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    font-family: ${props => `${props.theme.typography.fontFamily}`};
    font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
    &:focus {
      background-color: transparent;
    }
  }
  > div > svg {
    color: ${colors.orange};
    width: 3rem;
    height: 3rem;
    top: -0.4rem;
    right: 0;
    position: absolute;
  }
  &:before {
    content: none;
  }
  &:after {
    content: none;
  }
`;
const StyledMenuItem = styled(MenuItem)`
  font-family: ${props => `${props.theme.typography.fontFamily}`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
    &:focus {
      background-color: ${colors.orange} !important;
      color: white;
    }
    &:hover {
      background-color: ${colors.shades.orange.light} !important;
      color: white;
    }
  }
`;
class BlockChipMobile extends React.Component {
  state = {
    case: '',
  };
  handleChipChangeMobile = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.handleChipChange(event.target.value);
  };

  render() {
    const { data, activeChip } = this.props;
    return (
      <StyledGrid container justify={'center'} alignItems={'center'}>
        <StyledFormControl>
          <Grid
            container
            justify={'center'}
            alignItems={'center'}
            item
            xs={10}
            sm={6}
          >
            <StyledSelect
              value={activeChip}
              onChange={this.handleChipChangeMobile}
              name="case"
            >
              {data.map((chip, index) => {
                return (
                  <StyledMenuItem
                    value={chip.frontmatter.useCases}
                    key={`Chip${index}`}
                  >
                    <div>
                      <FormattedMessage
                        id={'useCases.' + chip.frontmatter.useCases}
                      />
                    </div>
                  </StyledMenuItem>
                );
              })}
            </StyledSelect>
          </Grid>
        </StyledFormControl>
      </StyledGrid>
    );
  }
}

export default BlockChipMobile;
